export const environment = {
  production: false,
  uat: false,
  staging: true,
  development: false,
  environment: 'staging',
  baseUrl: 'https://stg-wilson-api.tracwater.online',
  portalId: '6a17e001e98329553d9006dc',
  portalTypeId: '689596b618f8a8985a2aeb91'
};
